module.exports = __webpack_public_path__ + "static/media/52.b593d950.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/52.svg
// module id = 159
// module chunks = 0